const toast = ( opts ) => {
    let event = new Event( 'onToast' );

    event.data = {
        show: true,
        ...opts,
    };
    let dispatched = window.dispatchEvent( event );

    return new Promise( (resolve, reject) => dispatched ? resolve() : reject() )
};

export default toast;